import { matchValues } from '@shared/core/types/common';

const layout: OLO.Types.LAYOUT[] = ['row', 'column'];

export const layoutType = matchValues(...layout);
